import React, { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Loading } from '../loading';
import { useValidateInvitationQuery } from './accept-invite.queries.generated';

export const AcceptInvitation: React.FunctionComponent = () => {
    const [query] = useSearchParams();
    const token = query.get('token');
    const adminId = query.get('adminId');

    const { refetch, data, loading } = useValidateInvitationQuery({ variables: { token } });

    const { valid, isNewAdmin: isExistingAdminOrTokenExpired } = data?.invitation ?? {};

    useEffect(() => {
        refetch();
    }, [refetch]);

    if (loading) {
        return <Loading />;
    }

    if (valid && !isExistingAdminOrTokenExpired) {
        return (
            <Navigate
                to={{
                    pathname: '/welcome',
                    search: new URLSearchParams({ adminId, token }).toString(),
                }}
            />
        );
    }
    return <Navigate to={'/login/invalidtokenoradminexist'} />;
};
